var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDelaySend01 = function SvgDelaySend01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "data-name": "Layer 1",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "delay_send-01_svg2__a",
    x1: -7.27,
    x2: 168.92,
    y1: 116.76,
    y2: 1.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff3fe5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#f434e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#dd1de7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#cd0ce8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#c403e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c100e9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#delay_send-01_svg2__a",
    id: "delay_send-01_svg2__b",
    x1: 47.35,
    x2: 223.54,
    y1: 200.33,
    y2: 85.13
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#delay_send-01_svg2__a",
    id: "delay_send-01_svg2__c",
    x1: 47.42,
    x2: 223.61,
    y1: 200.4,
    y2: 85.2
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M87.5 133.33H16.67A8.33 8.33 0 0 1 8.34 125V34.34l72.35 59.7a4.18 4.18 0 0 0 5.31 0l72.34-59.82v36.61c0 2.3 1.87 4.17 4.17 4.17s4.17-1.87 4.17-4.17v-37.5c0-9.2-7.47-16.66-16.67-16.67H16.67C7.47 16.68 0 24.13 0 33.33V125c0 9.2 7.47 16.66 16.67 16.67H87.5c2.3 0 4.17-1.87 4.17-4.17s-1.87-4.17-4.17-4.17M16.67 25H150c1.64.04 3.22.58 4.55 1.54L83.33 85.43 12.04 26.59A8.06 8.06 0 0 1 16.67 25",
    style: {
      fill: "url(#delay_send-01_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.17 131.61V112.5c0-2.3-1.87-4.17-4.17-4.17s-4.17 1.87-4.17 4.17v20.83c0 1.11.44 2.17 1.22 2.95l12.5 12.5a4.167 4.167 0 0 0 5.89-5.89l-11.28-11.28Z",
    style: {
      fill: "url(#delay_send-01_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150 83.33c-27.61 0-50 22.39-50 50s22.39 50 50 50 50-22.39 50-50c-.03-27.6-22.4-49.97-50-50m0 91.67c-23.01 0-41.67-18.65-41.67-41.67S126.98 91.66 150 91.66s41.67 18.65 41.67 41.67c-.03 23-18.67 41.64-41.67 41.67",
    style: {
      fill: "url(#delay_send-01_svg2__c)"
    }
  }));
};
export default SvgDelaySend01;